import { SalesBookingFormName } from '@heidi/schema/ml-scribe';
import { useQueryUser } from '@heidi/workspace/data';

/**
 * Whether the user has already submitted the trial upgrade sales-booking form,
 * per {@link UserResponse.sales_booking_forms_submitted}.
 */
export function useHasTrialUpgradeCallbackRequested(): boolean {
  const { data: hasCallbackRequested = false } = useQueryUser((user) =>
    Boolean(
      user.sales_booking_forms_submitted?.[SalesBookingFormName.clinician_trial_upgrade]
    )
  );

  return hasCallbackRequested;
}
